import styled from 'styled-components'
import React from "react"
import { navigate } from 'gatsby'
import { usePageContext }  from '../hooks/usePageContext'


const LangSwitcherStrip = () => {
  const {paths,lang ,languages} = usePageContext()
  const FullLangNames = {en: 'English',es: 'Español', de: 'Deutsch', fr: 'Français'}
  const availableLanguages = languages.filter(language => paths[language]).filter(language => !paths[language]?.includes("undefined"))
  const switchLanguages= (language) => {
    navigate(paths[language])
  }

  return(
    <>
      {languages.length > 1 &&
        <Wrapper>
          {availableLanguages.map((language,index) => (
            <LangOption 
              key={index}
              $activeLang={lang === language}
              onClick={()=> switchLanguages(language)}>
                {FullLangNames[language]}
            </LangOption>
          ))}
        </Wrapper>
      }
    </>
  )
}

export default LangSwitcherStrip




const Wrapper = styled.div`
  background-color: #F19D9A;
  display:flex;
  align-items: center;
  justify-content: center;
  height:45px;
  @media (max-width: 449px) {
    padding: 0px 10px;
    justify-content:space-around;
  }
`

const LangOption = styled.button`
  background-color:${props => props.$activeLang ? 'white' : 'transparent'};
  color: ${props => props.$activeLang ? '#F19D9A' : 'white'};
  border-radius:13px;
  font-size:12px;
  height:27px;
  padding: 0 20px;
  text-align:center;
   margin: auto 10px;
  font-weight: 500;
  border:1px solid white;
  text-transform:uppercase;
  @media (max-width:450px) {
    font-size:10px;
    padding: 0 15px;
    margin: 0;
  }
  @media (max-width:320px) {
    font-size:10px;
    padding: 0 8px;
    margin: auto 4px;
  }
`